/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Match } from './Match';
import {
    MatchFromJSON,
    MatchFromJSONTyped,
    MatchToJSON,
    MatchToJSONTyped,
} from './Match';

/**
 * 
 * @export
 * @interface ConfirmResultResponse
 */
export interface ConfirmResultResponse {
    /**
     * 
     * @type {Match}
     * @memberof ConfirmResultResponse
     */
    match: Match;
    /**
     * 
     * @type {string}
     * @memberof ConfirmResultResponse
     */
    message: string;
}

/**
 * Check if a given object implements the ConfirmResultResponse interface.
 */
export function instanceOfConfirmResultResponse(value: object): value is ConfirmResultResponse {
    if (!('match' in value) || value['match'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ConfirmResultResponseFromJSON(json: any): ConfirmResultResponse {
    return ConfirmResultResponseFromJSONTyped(json, false);
}

export function ConfirmResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'match': MatchFromJSON(json['match']),
        'message': json['message'],
    };
}

export function ConfirmResultResponseToJSON(json: any): ConfirmResultResponse {
    return ConfirmResultResponseToJSONTyped(json, false);
}

export function ConfirmResultResponseToJSONTyped(value?: ConfirmResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'match': MatchToJSON(value['match']),
        'message': value['message'],
    };
}

